import { register } from '../../../../Javascript/Sysmex/Utils'

const QuizModule = el => {
  const prefix = el.dataset.prefix
  const answers = el.querySelectorAll(`.${prefix}answer`)
  const progressItems = el.querySelectorAll(`.${prefix}progressItem`)
  const questionItems = el.querySelectorAll(`.${prefix}questionItem`)
  const nextButton = el.querySelector(`.${prefix}quizNext`)
  const backButton = el.querySelector(`.${prefix}quizBack`)
  const numOfQuestions = questionItems.length

  const init = () => {
    progressItems.forEach((item, index) => {
      item.id = `progressItem-${index + 1}`
      item.dataset.questionid = index + 1
      item.querySelector(`.${prefix}numerator`).innerText = index + 1
      item.querySelector(`.${prefix}numerator2`).innerText = index + 1
      if (index === 0) {
        item.classList.add(`${prefix}is--active`)
      }
    })
    questionItems.forEach((item, index) => {
      const innerHeight = item.querySelector(`.${prefix}questionWrapper`).scrollHeight
      item.style.height = `${innerHeight}px`
      item.classList.add(`${prefix}is--measured`)
      item.id = `questionItem-${index + 1}`
      item.dataset.questionid = index + 1
      item.querySelector(`.${prefix}numerator3`).innerText = index + 1
      if (index === 0) {
        item.classList.add(`${prefix}is--active`)
      }
    })
  }

  init()

  answers.forEach(answer => {
    answer.addEventListener('click', e => {
      answer.classList.add(`${prefix}is--touched`)
    })
  })

  nextButton.addEventListener('click', e => {
    const currentQuestion = el.querySelector(`.${prefix}questionItem.${prefix}is--active`)

    if (currentQuestion.classList.contains(`${prefix}is--solved`)) {
      gotoNext()
    } else {
      resolve()
    }
  })

  backButton.addEventListener('click', e => {
    gotoPrevious()
  })

  const checkButtons = (current) => {
    nextButton.classList.remove(`${prefix}is--disabled`)
    backButton.classList.remove(`${prefix}is--disabled`)

    if (current === numOfQuestions) {
      // nextButton.classList.add(`${prefix}is--disabled`)
    }

    if (current === 1) {
      backButton.classList.add(`${prefix}is--disabled`)
    }
  }

  const resolve = () => {
    const currentQuestion = el.querySelector(`.${prefix}questionItem.${prefix}is--active`)
    const currentQuestionId = +currentQuestion.dataset.questionid
    const currentAnswers = currentQuestion.querySelectorAll(`.${prefix}answer`)

    let isValid = true
    currentAnswers.forEach(answer => {
      const answerIsChecked = answer.querySelector('input[type="checkbox"], input[type="radio"]').checked
      const answerIsCorrect = !!+answer.dataset.iscorrect // convert to string and check if 1, then convert to bool

      if (answer.classList.contains(`${prefix}is--touched`)) {
        if (answerIsChecked === answerIsCorrect) {
          answer.classList.remove(`${prefix}is--false`)
          answer.classList.add(`${prefix}is--correct`)
        } else {
          answer.classList.remove(`${prefix}is--correct`)
          answer.classList.add(`${prefix}is--false`)
        }
      }

      isValid = isValid && (answerIsChecked === answerIsCorrect)
    })

    if (isValid) {
      currentAnswers.forEach(answer => {
        answer.classList.remove(`${prefix}is--false`)
        answer.classList.add(`${prefix}is--correct`)
      })

      currentQuestion.classList.add(`${prefix}is--solved`)
      checkButtons(currentQuestionId)
    }
  }

  const gotoNext = () => {
    const currentQuestion = el.querySelector(`.${prefix}questionItem.${prefix}is--active`)
    const currentQuestionId = +currentQuestion.dataset.questionid

    if (currentQuestionId >= numOfQuestions) {
      el.classList.add(`${prefix}is--finished`)

      if (window.dataLayer) {
        window.dataLayer.push({ event: 'AMRQuizEvent', 'amr-quiz-event': 'quiz-finished' })
      }

      return
    }

    const nextQuestion = document.getElementById(`questionItem-${currentQuestionId + 1}`)
    const currentProgressItem = el.querySelector(`.${prefix}progressItem.${prefix}is--active`)
    const nextProgressItem = document.getElementById(`progressItem-${currentQuestionId + 1}`)

    currentQuestion.classList.remove(`${prefix}is--active`)
    nextQuestion.classList.add(`${prefix}is--active`)

    currentProgressItem.classList.remove(`${prefix}is--active`)
    currentProgressItem.classList.add(`${prefix}is--done`)
    nextProgressItem.classList.add(`${prefix}is--active`)

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'AMRQuizEvent', 'amr-quiz-event': `goto-next-${currentQuestionId + 1}` })
    }

    // todo: besser wäre: quiz object mit aktuellem stand, funktion change question
    checkButtons(currentQuestionId + 1)
  }

  // todo: Goto Next und Prevous in EINE Funktion

  const gotoPrevious = () => {
    const currentQuestion = el.querySelector(`.${prefix}questionItem.${prefix}is--active`)
    const currentQuestionId = +currentQuestion.dataset.questionid
    const nextQuestion = document.getElementById(`questionItem-${currentQuestionId - 1}`)
    const currentProgressItem = el.querySelector(`.${prefix}progressItem.${prefix}is--active`)
    const nextProgressItem = document.getElementById(`progressItem-${currentQuestionId - 1}`)

    currentQuestion.classList.remove(`${prefix}is--active`)
    nextQuestion.classList.add(`${prefix}is--active`)

    currentProgressItem.classList.remove(`${prefix}is--active`)
    nextProgressItem.classList.add(`${prefix}is--active`)

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'AMRQuizEvent', 'amr-quiz-event': `goto-previous-${currentQuestionId - 1}` })
    }

    checkButtons(currentQuestionId - 1)
  }
}

register('QuizModule', QuizModule)

// todo: kleine animation css für active navbar item + is-done explanation text

// Next Button 2 states: resolve, gotoNext
// todo: wenn folie solved, css pointer events aus + graue flächen + cursor normal
